'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Themes to use in components

var PRIMARY = 'primary';
var SECONDARY = 'secondary';
var TERTIARY = 'tertiary';
var LINK = 'link';

var BUTTON_THEMES = exports.BUTTON_THEMES = [PRIMARY, SECONDARY, TERTIARY, LINK];